export default __webpack_public_path__ + "static/media/dd-icon-1.382fdb86.png";